<template>
  <transition
    name="collapse"
    @enter="onEnter"
    @after-enter="onAfterEnter"
    @leave="onLeave"
  >
    <slot />
  </transition>
</template>

<script>
export default {
  name: "CollapseTransition",
  props: {
    /** Transition length in ms. Matches the drawer's 0.3s family by default. */
    duration: {
      type: Number,
      default: 240,
    },
  },
  computed: {
    reduced() {
      return window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    },
  },
  methods: {
    onEnter(el, done) {
      if (this.reduced) {
        el.style.height = "auto";
        done();
        return;
      }
      el.style.height = "0";
      el.style.overflow = "hidden";
      // Read scrollHeight only after the browser has laid the element out at
      // zero height, otherwise the target height is the previous frame's.
      void el.offsetHeight;
      el.style.transition = `height ${this.duration}ms cubic-bezier(0.4, 0, 0.2, 1)`;
      el.style.height = `${el.scrollHeight}px`;
      setTimeout(done, this.duration);
    },
    // Released to `auto` so the body can still grow while a turn streams into it.
    onAfterEnter(el) {
      el.style.height = "auto";
      el.style.overflow = "";
      el.style.transition = "";
    },
    onLeave(el, done) {
      if (this.reduced) {
        done();
        return;
      }
      el.style.height = `${el.offsetHeight}px`;
      el.style.overflow = "hidden";
      void el.offsetHeight;
      el.style.transition = `height ${this.duration}ms cubic-bezier(0.4, 0, 0.2, 1)`;
      el.style.height = "0";
      setTimeout(done, this.duration);
    },
  },
};
</script>
